// Global Types
import type {
  $Model,
  $ModelUpdateParams,
} from 'common.data';

// Global Enums
import {
  AdminAuthType,
} from 'common.data';

import * as authActionTypes from './types';

// Types
import type {
  $Services,
} from '../../../services';
import type {
  $Action,
  $ActionResult,
  $Dispatch,
  $State,
} from '../..';

// setupAuthentication action
type $SetupAuthenticationActionParams = void;
type $SetupAuthenticationActionResponse = $Model<'Admin'> | null;
export type $SetupAuthenticationAction = (
  arg0: $SetupAuthenticationActionParams,
) => $ActionResult<$SetupAuthenticationActionResponse>;

export const setupAuthentication: $Action<
$SetupAuthenticationActionResponse,
$SetupAuthenticationActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.getAuthUser(),
  type: authActionTypes.SETUP_AUTHENTICATION,
});

// cleanAuthentication action
type $CleanAuthenticationActionParams = void;
type $CleanAuthenticationActionResponse = void;
export type $CleanAuthenticationAction = (
  arg0: $CleanAuthenticationActionParams,
) => $ActionResult<$CleanAuthenticationActionResponse>;

export const cleanAuthentication: $Action<
$CleanAuthenticationActionResponse,
$CleanAuthenticationActionParams
> = () => (
  dispatch: $Dispatch,
) => dispatch({
  payload: async () => {},
  type: authActionTypes.CLEAN_AUTHENTICATION,
});

// authenticate action
type $AuthenticateActionParams = {
  token: string;
  type: AdminAuthType;
};
type $AuthenticateActionResponse = $Model<'Admin'>;
export type $AuthenticateAction = (
  arg0: $AuthenticateActionParams,
) => $ActionResult<$AuthenticateActionResponse>;

export const authenticate: $Action<
$AuthenticateActionResponse,
$AuthenticateActionParams
> = (params) => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.authenticate(params),
  type: authActionTypes.AUTHENTICATE,
});

// unauthenticate action
type $UnauthenticateActionParams = void;
type $UnauthenticateActionResponse = void;
export type $UnauthenticateAction = (
  arg0: $UnauthenticateActionParams,
) => $ActionResult<$UnauthenticateActionResponse>;

export const unauthenticate: $Action<
$UnauthenticateActionResponse,
$UnauthenticateActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: () => services.Api.unauthenticate(),
  type: authActionTypes.UNAUTHENTICATE,
});

// forgotPassword action
type $ForgotPasswordActionParams = {
  Email: string;
};
type $ForgotPasswordActionResponse = {
  id: string;
};
export type $ForgotPasswordAction = (
  arg0: $ForgotPasswordActionParams,
) => $ActionResult<$ForgotPasswordActionResponse>;

export const forgotPassword: $Action<
$ForgotPasswordActionResponse,
$ForgotPasswordActionParams
> = (params) => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.forgotPassword(params),
  type: authActionTypes.FORGOT_PASSWORD,
});

// resetPassword action
type $ResetPasswordActionParams = {
  CnfPassword: string;
  Code: string;
  id: string;
  NewPassword: string;
};
type $ResetPasswordActionResponse = $Model<'Admin'>;
export type $ResetPasswordAction = (
  arg0: $ResetPasswordActionParams,
) => $ActionResult<$ResetPasswordActionResponse>;

export const resetPassword: $Action<
$ResetPasswordActionResponse,
$ResetPasswordActionParams
> = (params) => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.resetPassword(params),
  type: authActionTypes.RESET_PASSWORD,
});

// getAuthUser action
type $GetAuthUserActionParams = void;
type $GetAuthUserActionResponse = $Model<'Admin'> | null;
export type $GetAuthUserAction = (
  arg0: $GetAuthUserActionParams,
) => $ActionResult<$GetAuthUserActionResponse>;

export const getAuthUser: $Action<
$GetAuthUserActionResponse,
$GetAuthUserActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.getAuthUser(),
  type: authActionTypes.GET_AUTH_USER,
});

// updateAuthUser action
type $UpdateAuthUserActionParams = $ModelUpdateParams<'Admin'> & {
  NewPassword?: null | string;
  OldPassword?: null | string;
};
type $UpdateAuthUserActionResponse = $Model<'Admin'>;
export type $UpdateAuthUserAction = (
  arg0: $UpdateAuthUserActionParams,
) => $ActionResult<$UpdateAuthUserActionResponse>;

export const updateAuthUser: $Action<
$UpdateAuthUserActionResponse,
$UpdateAuthUserActionParams
> = (params) => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.updateAuthUser(params),
  type: authActionTypes.UPDATE_AUTH_USER,
});

// deleteAuthUser action
type $DeleteAuthUserActionParams = void;
type $DeleteAuthUserActionResponse = $Model<'Admin'>;
export type $DeleteAuthUserAction = (
  arg0: $DeleteAuthUserActionParams,
) => $ActionResult<$DeleteAuthUserActionResponse>;

export const deleteAuthUser: $Action<
$DeleteAuthUserActionResponse,
$DeleteAuthUserActionParams
> = () => (
  dispatch: $Dispatch,
  getState: () => $State,
  services: $Services,
) => dispatch({
  payload: async () => services.Api.deleteAuthUser(),
  type: authActionTypes.DELETE_AUTH_USER,
});
